import clsx from 'clsx';
import { Icon } from 'common/icon';
import styles from './styles.module.css';

type Props = {
  isOpen?: boolean;
  size?: 'small' | 'medium';
};

export const SelectArrow = ({ isOpen, size }: Props) => {
  return (
    <div
      className={clsx(styles.arrow, styles[`${size}`], {
        [styles.open]: isOpen,
        [styles.close]: !isOpen,
      })}
    >
      <Icon.Arrow />
    </div>
  );
};
